/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Citizen } from '../models';
// @ts-ignore
import type { Discount } from '../models';
// @ts-ignore
import type { ServiceRequest } from '../models';
/**
 * AdminDiscountApi - axios parameter creator
 * @export
 */
export const AdminDiscountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  **Permission required**: [\"create\", \"Discount\"] 
         * @summary Create a new discount | Permission required: [\"create\", \"Discount\"]
         * @param {Discount} [discount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiscount: async (discount?: Discount, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/discount/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(discount, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readAll\", \"Citizen\"] 
         * @summary Get all citizen from discount by id | Permission required: [\"readAll\", \"Citizen\"]
         * @param {number} id 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCitizenFromDiscountById: async (id: number, filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAllCitizenFromDiscountById', 'id', id)
            const localVarPath = `/admin/discount/{id}/citizens`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readAll\", \"Discount\"] 
         * @summary Get all data from discount by id | Permission required: [\"readAll\", \"Discount\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDataFromDiscountById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAllDataFromDiscountById', 'id', id)
            const localVarPath = `/admin/discount/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readAll\", \"Discount\"] 
         * @summary Get all discounts | Permission required: [\"readAll\", \"Discount\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {string} [startDateBefore] 
         * @param {string} [startDateAfter] 
         * @param {string} [expiryDateBefore] 
         * @param {string} [expiryDateAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDiscounts: async (filter?: string, startDateBefore?: string, startDateAfter?: string, expiryDateBefore?: string, expiryDateAfter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/discount/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (startDateBefore !== undefined) {
                localVarQueryParameter['startDateBefore'] = startDateBefore;
            }

            if (startDateAfter !== undefined) {
                localVarQueryParameter['startDateAfter'] = startDateAfter;
            }

            if (expiryDateBefore !== undefined) {
                localVarQueryParameter['expiryDateBefore'] = expiryDateBefore;
            }

            if (expiryDateAfter !== undefined) {
                localVarQueryParameter['expiryDateAfter'] = expiryDateAfter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary Get all service requests from discount by id | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {number} id 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllServiceRequestsFromDiscountById: async (id: number, filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAllServiceRequestsFromDiscountById', 'id', id)
            const localVarPath = `/admin/discount/{id}/serviceRequests`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"Discount\"] 
         * @summary Update discount | Permission required: [\"update\", \"Discount\"]
         * @param {Discount} [discount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiscount: async (discount?: Discount, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/discount/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(discount, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDiscountApi - functional programming interface
 * @export
 */
export const AdminDiscountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDiscountApiAxiosParamCreator(configuration)
    return {
        /**
         *  **Permission required**: [\"create\", \"Discount\"] 
         * @summary Create a new discount | Permission required: [\"create\", \"Discount\"]
         * @param {Discount} [discount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDiscount(discount?: Discount, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Discount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDiscount(discount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDiscountApi.createDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readAll\", \"Citizen\"] 
         * @summary Get all citizen from discount by id | Permission required: [\"readAll\", \"Citizen\"]
         * @param {number} id 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCitizenFromDiscountById(id: number, filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Citizen>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCitizenFromDiscountById(id, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDiscountApi.getAllCitizenFromDiscountById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readAll\", \"Discount\"] 
         * @summary Get all data from discount by id | Permission required: [\"readAll\", \"Discount\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDataFromDiscountById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Discount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDataFromDiscountById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDiscountApi.getAllDataFromDiscountById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readAll\", \"Discount\"] 
         * @summary Get all discounts | Permission required: [\"readAll\", \"Discount\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {string} [startDateBefore] 
         * @param {string} [startDateAfter] 
         * @param {string} [expiryDateBefore] 
         * @param {string} [expiryDateAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDiscounts(filter?: string, startDateBefore?: string, startDateAfter?: string, expiryDateBefore?: string, expiryDateAfter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Discount>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDiscounts(filter, startDateBefore, startDateAfter, expiryDateBefore, expiryDateAfter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDiscountApi.getAllDiscounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary Get all service requests from discount by id | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {number} id 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllServiceRequestsFromDiscountById(id: number, filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceRequest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllServiceRequestsFromDiscountById(id, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDiscountApi.getAllServiceRequestsFromDiscountById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"Discount\"] 
         * @summary Update discount | Permission required: [\"update\", \"Discount\"]
         * @param {Discount} [discount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDiscount(discount?: Discount, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Discount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDiscount(discount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDiscountApi.updateDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminDiscountApi - factory interface
 * @export
 */
export const AdminDiscountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDiscountApiFp(configuration)
    return {
        /**
         *  **Permission required**: [\"create\", \"Discount\"] 
         * @summary Create a new discount | Permission required: [\"create\", \"Discount\"]
         * @param {Discount} [discount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiscount(discount?: Discount, options?: RawAxiosRequestConfig): AxiosPromise<Discount> {
            return localVarFp.createDiscount(discount, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readAll\", \"Citizen\"] 
         * @summary Get all citizen from discount by id | Permission required: [\"readAll\", \"Citizen\"]
         * @param {number} id 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCitizenFromDiscountById(id: number, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Citizen>> {
            return localVarFp.getAllCitizenFromDiscountById(id, filter, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readAll\", \"Discount\"] 
         * @summary Get all data from discount by id | Permission required: [\"readAll\", \"Discount\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDataFromDiscountById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Discount> {
            return localVarFp.getAllDataFromDiscountById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readAll\", \"Discount\"] 
         * @summary Get all discounts | Permission required: [\"readAll\", \"Discount\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {string} [startDateBefore] 
         * @param {string} [startDateAfter] 
         * @param {string} [expiryDateBefore] 
         * @param {string} [expiryDateAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDiscounts(filter?: string, startDateBefore?: string, startDateAfter?: string, expiryDateBefore?: string, expiryDateAfter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Discount>> {
            return localVarFp.getAllDiscounts(filter, startDateBefore, startDateAfter, expiryDateBefore, expiryDateAfter, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary Get all service requests from discount by id | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {number} id 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllServiceRequestsFromDiscountById(id: number, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceRequest>> {
            return localVarFp.getAllServiceRequestsFromDiscountById(id, filter, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"Discount\"] 
         * @summary Update discount | Permission required: [\"update\", \"Discount\"]
         * @param {Discount} [discount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiscount(discount?: Discount, options?: RawAxiosRequestConfig): AxiosPromise<Discount> {
            return localVarFp.updateDiscount(discount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDiscountApi - interface
 * @export
 * @interface AdminDiscountApi
 */
export interface AdminDiscountApiInterface {
    /**
     *  **Permission required**: [\"create\", \"Discount\"] 
     * @summary Create a new discount | Permission required: [\"create\", \"Discount\"]
     * @param {Discount} [discount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApiInterface
     */
    createDiscount(discount?: Discount, options?: RawAxiosRequestConfig): AxiosPromise<Discount>;

    /**
     *  **Permission required**: [\"readAll\", \"Citizen\"] 
     * @summary Get all citizen from discount by id | Permission required: [\"readAll\", \"Citizen\"]
     * @param {number} id 
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApiInterface
     */
    getAllCitizenFromDiscountById(id: number, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Citizen>>;

    /**
     *  **Permission required**: [\"readAll\", \"Discount\"] 
     * @summary Get all data from discount by id | Permission required: [\"readAll\", \"Discount\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApiInterface
     */
    getAllDataFromDiscountById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Discount>;

    /**
     *  **Permission required**: [\"readAll\", \"Discount\"] 
     * @summary Get all discounts | Permission required: [\"readAll\", \"Discount\"]
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {string} [startDateBefore] 
     * @param {string} [startDateAfter] 
     * @param {string} [expiryDateBefore] 
     * @param {string} [expiryDateAfter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApiInterface
     */
    getAllDiscounts(filter?: string, startDateBefore?: string, startDateAfter?: string, expiryDateBefore?: string, expiryDateAfter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Discount>>;

    /**
     *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
     * @summary Get all service requests from discount by id | Permission required: [\"readAll\", \"ServiceRequest\"]
     * @param {number} id 
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApiInterface
     */
    getAllServiceRequestsFromDiscountById(id: number, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceRequest>>;

    /**
     *  **Permission required**: [\"update\", \"Discount\"] 
     * @summary Update discount | Permission required: [\"update\", \"Discount\"]
     * @param {Discount} [discount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApiInterface
     */
    updateDiscount(discount?: Discount, options?: RawAxiosRequestConfig): AxiosPromise<Discount>;

}

/**
 * AdminDiscountApi - object-oriented interface
 * @export
 * @class AdminDiscountApi
 * @extends {BaseAPI}
 */
export class AdminDiscountApi extends BaseAPI implements AdminDiscountApiInterface {
    /**
     *  **Permission required**: [\"create\", \"Discount\"] 
     * @summary Create a new discount | Permission required: [\"create\", \"Discount\"]
     * @param {Discount} [discount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApi
     */
    public createDiscount(discount?: Discount, options?: RawAxiosRequestConfig) {
        return AdminDiscountApiFp(this.configuration).createDiscount(discount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readAll\", \"Citizen\"] 
     * @summary Get all citizen from discount by id | Permission required: [\"readAll\", \"Citizen\"]
     * @param {number} id 
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApi
     */
    public getAllCitizenFromDiscountById(id: number, filter?: string, options?: RawAxiosRequestConfig) {
        return AdminDiscountApiFp(this.configuration).getAllCitizenFromDiscountById(id, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readAll\", \"Discount\"] 
     * @summary Get all data from discount by id | Permission required: [\"readAll\", \"Discount\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApi
     */
    public getAllDataFromDiscountById(id: number, options?: RawAxiosRequestConfig) {
        return AdminDiscountApiFp(this.configuration).getAllDataFromDiscountById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readAll\", \"Discount\"] 
     * @summary Get all discounts | Permission required: [\"readAll\", \"Discount\"]
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {string} [startDateBefore] 
     * @param {string} [startDateAfter] 
     * @param {string} [expiryDateBefore] 
     * @param {string} [expiryDateAfter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApi
     */
    public getAllDiscounts(filter?: string, startDateBefore?: string, startDateAfter?: string, expiryDateBefore?: string, expiryDateAfter?: string, options?: RawAxiosRequestConfig) {
        return AdminDiscountApiFp(this.configuration).getAllDiscounts(filter, startDateBefore, startDateAfter, expiryDateBefore, expiryDateAfter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
     * @summary Get all service requests from discount by id | Permission required: [\"readAll\", \"ServiceRequest\"]
     * @param {number} id 
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApi
     */
    public getAllServiceRequestsFromDiscountById(id: number, filter?: string, options?: RawAxiosRequestConfig) {
        return AdminDiscountApiFp(this.configuration).getAllServiceRequestsFromDiscountById(id, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"Discount\"] 
     * @summary Update discount | Permission required: [\"update\", \"Discount\"]
     * @param {Discount} [discount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApi
     */
    public updateDiscount(discount?: Discount, options?: RawAxiosRequestConfig) {
        return AdminDiscountApiFp(this.configuration).updateDiscount(discount, options).then((request) => request(this.axios, this.basePath));
    }
}

